module.exports = __webpack_public_path__ + "static/media/dropdownArrowWhite.e81116a9.svg";